import Storage from './storage';
import { getTokenExpiresAt, getPayload } from './json-web-token';
import Mitt from 'mitt';

export const Emitter = Mitt();

export function getTokenWithExpiry() {
  const token = Storage.getItem('authToken');
  if (!token) {
    return null;
  }
  const payload = getPayload(token);
  if (!payload) {
    return null;
  }
  const expiresAt = getTokenExpiresAt(token);
  return {
    token,
    expiresAt
  };
}

export function getToken() {
  const tokenAndExpiry = getTokenWithExpiry();
  if (!tokenAndExpiry) {
    return null;
  }
  const { expiresAt, token } = tokenAndExpiry;
  if (typeof expiresAt === 'number' && expiresAt < Date.now()) {
    return null;
  }
  return token;
}

export function setToken(token) {
  Storage.setItem('authToken', token);
  Emitter.emit('authenticated', token);
}

export function deleteToken() {
  Storage.removeItem('authToken');
  Emitter.emit('unauthenticated');
}


// WEBPACK FOOTER //
// ./src/services/authentication.js